import { useSearchFields } from '../../SearchFieldProvider';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select'
import { categoryLabels, mediaLabels } from '../../constants';

export default function MobileInputs() {
    const navigate = useNavigate();
    const { keyword, setKeyword, setLocation, location, setStartDate, startDate, endDate, setEndDate, showModal, setShowModal, categories, setCategories, media, setMedia } = useSearchFields();
    const [keywordInput, setKeywordInput] = useState(keyword);
    const [locationInput, setLocationInput] = useState(location);
    const [startDateInput, setStartDateInput] = useState(startDate);
    const [endDateInput, setEndDateInput] = useState(endDate);
    const [showWhere, setShowWhere] = useState(true);
    const [showWhat, setShowWhat] = useState(false);
    const [showWhen, setShowWhen] = useState(false);

    const [categorySelected, setCategorySelected] = useState(categories);
    const handleCategoryChange = (selected) => {
        setCategorySelected(selected);
    };
    const [mediumSelected, setMediumSelected] = useState(media);
    const handleMediumChange = (selected) => {
        setMediumSelected(selected);
    };

    const onClick = (show, setShow) => {
        setShow(!show);
    };

    async function onSubmit() {
        const catsToPass = categorySelected.filter((elem) => elem.value);
        const medToPass = mediumSelected.filter((elem) => elem.value);

        setShowModal(false); 
        setKeyword(keywordInput);
        setLocation(locationInput);
        setStartDate(startDateInput);
        setEndDate(endDateInput);
        setCategories(catsToPass);
        setMedia(medToPass);
        navigate('/searchResults');
    };

    const onClear = () => {
        setKeywordInput("");
        setLocationInput("");
        setStartDateInput("");
        setEndDateInput("");
        setCategorySelected([]);
        setMediumSelected([]);
    }

    const show = showModal ? 'container' : 'd-none';

    document.addEventListener("keydown", e => {
        if (e.key === "Enter" || e.keyCode === 13) {
            onSubmit();
        }
    });

    function convertDate(dateString) {
        const [month, day, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };
      

    const setToday = () => {
        const todayDate = new Date();
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const today = todayDate.toLocaleTimeString('en-US', options).slice(0,10);
        const todayFormatted = convertDate(today);
        console.log(todayFormatted)
        setStartDateInput(todayFormatted);
        setEndDateInput(todayFormatted);
    };

    function addDays(date, days) {
        const newDate = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
        return newDate;
    };

    const setTomorrow = () => {
        const todayDate = new Date();
        const tomorrowDate = addDays(todayDate, 1);
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const tomorrow = tomorrowDate.toLocaleTimeString('en-US', options).slice(0,10);
        const tomorrowFormatted = convertDate(tomorrow);
        setStartDateInput(tomorrowFormatted);
        setEndDateInput(tomorrowFormatted);
    };

    const getNextWeekendDates = () => {
        const today = new Date();
        let dayOfWeek = today.getDay(); // 0 for Sunday, 1 for Monday, etc.
      
        // Calculate days until next Saturday
        let daysUntilSaturday = 6 - dayOfWeek; 
        if (daysUntilSaturday === 0) {
          daysUntilSaturday = 7; // If today is Saturday, go to next Saturday
        }
      
        const nextSaturday = new Date(today);
        nextSaturday.setDate(today.getDate() + daysUntilSaturday);
      
        const nextSunday = new Date(nextSaturday);
        nextSunday.setDate(nextSaturday.getDate() + 1);

        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const sat = nextSaturday.toLocaleTimeString('en-US', options).slice(0,10);
        const satFormatted = convertDate(sat);

        const sun = nextSunday.toLocaleTimeString('en-US', options).slice(0,10);
        const sunFormatted = convertDate(sun);

        setStartDateInput(satFormatted);
        setEndDateInput(sunFormatted);

        return {
          saturday: nextSaturday,
          sunday: nextSunday,
        };
      }


    return (
        <div className={show}>
            <div className='row justify-content-end'>
                <button id="closeButton" type="button" className="btn-close" aria-label="Close" onClick={() => {setShowModal(false)}}></button>
            </div>

            <div className='container'>
                <div className='row py-3'>
                    <div className='col-auto me-auto'>
                        <div className="h6">Where</div>
                    </div>
                    <div className='col-auto'>
                        <button type="button" className="btn" onClick={() => {onClick(showWhere, setShowWhere)}}>
                            <i className="fa fa-angle-down"></i>
                        </button>
                    </div>
                    {showWhere && (
                        <div className='container'>
                            <input type="text" className="form-control d-md-block" placeholder="Location" aria-label="Location" style={{ borderRadius: 500}}
                            onChange={event => setLocationInput(event.target.value)} value={locationInput}/>
                        </div>
                    )}
                </div>
            </div>

            <div className='container'>
                <div className='row py-3'>
                    <div className='col-auto me-auto'>
                        <div className="h6">What</div>
                    </div>
                    <div className='col-auto'>
                        <button type="button" className="btn" onClick={() => {onClick(showWhat, setShowWhat)}}>
                            <i className="fa fa-angle-down"></i>
                        </button>
                    </div>
                    {showWhat && (
                        <div className='container'>
                            <input type="text" className="form-control d-md-block mb-3" placeholder="Keyword" aria-label="Keyword" style={{ borderRadius: 500}}
                            onChange={event => setKeywordInput(event.target.value)} value={keywordInput}/>
                            <Select
                                isClearable={true}
                                closeMenuOnSelect={true}
                                isMulti
                                menuPlacement="auto"
                                name="Category"
                                placeholder="Category"
                                options={categoryLabels}
                                className="basic-multi-select pb-3"
                                classNamePrefix="select"
                                onChange={handleCategoryChange}
                                value={categorySelected}
                                styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderRadius: 20,
                                    }),
                                  }}
                            />
                            <Select
                                isClearable={true}
                                closeMenuOnSelect={true}
                                isMulti
                                menuPlacement="auto"
                                name="Medium"
                                placeholder="Medium"
                                options={mediaLabels}
                                className="basic-multi-select pb-3"
                                classNamePrefix="select"
                                onChange={handleMediumChange}
                                value={mediumSelected}
                                styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderRadius: 20,
                                    }),
                                  }}
                            />
                        </div>
                    )}
                </div>
            </div>

            <div className='container'>
                <div className='row py-3'>
                    <div className='col-auto me-auto'>
                        <div className="h6">When</div>
                    </div>
                    <div className='col-auto'>
                        <button type="button" className="btn" onClick={() => {onClick(showWhen, setShowWhen)}}>
                            <i className="fa fa-angle-down"></i>
                        </button>
                    </div>
                    {showWhen && (
                        <div className='container'>
                            <div className="row pb-2">
                                <button type="button" className="btn btn-outline-dark" onClick={setToday}>Today</button>
                            </div>
                            <div className="row pb-2">
                                <button type="button" className="btn btn-outline-dark" onClick={setTomorrow}>Tomorrow</button>
                            </div>
                            <div className="row pb-2">
                                <button type="button" className="btn btn-outline-dark" onClick={getNextWeekendDates}>This weekend</button>
                            </div>
                            <label htmlFor="from" className="form-label">From</label>
                            <input id="startDate" type="date" className="form-control mb-3" placeholder="Start" style={{ borderRadius: 500}} onChange={event => setStartDateInput(event.target.value)} value={startDateInput}/>
                            <label htmlFor="to" className="form-label">To</label>
                            <input id="endDate" type="date" className="form-control" onChange={event => setEndDateInput(event.target.value)} value={endDateInput} placeholder="End" style={{ borderRadius: 500}}/>
                        </div>
                    )}
                </div>
            </div>

            <div className="navbar fixed-bottom" data-bs-theme="light">
                <div className='container' style={{border: "1px solid black"}}>
                <div className='row py-3 mx-auto'>
                    <div className='col-auto me-auto'>
                        <button type="button" className="btn btn-outline-dark" onClick={onClear}>Clear</button>
                    </div>
                    <div className='col-auto'>
                        <span>
                            <button type="button" className="btn btn-dark" onClick={onSubmit}>Search  
                                <i className="fa fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div> 
                </div>            
            </div>
        </div>
    );
}